import {
  Group,
  Stack,
  Title,
} from '@mantine/core'
import StatusPill from '../../common/pill-status'
import { FacilityParams } from 'app/models/facility-params'
import { NonProRataIconWithTooltip } from 'app/views/components/icons/NonProRataIconWithTooltip'
import FacilityHoldIndicator from 'app/views/components/facility-hold-indicator'


interface props {
  facility: FacilityParams,
  customTitle?: string
  showStatusPill?: boolean
}

export default function FacilityHeader({ facility, customTitle, showStatusPill = true }: props): JSX.Element {
  return (
    <Stack className="detailsHeader">
      <Group noWrap>
        {customTitle ?
          <Title className='detailsTitle'>{customTitle}</Title> :
          <Title className='detailsTitle'>{facility ? facility.name : ''}</Title>}
        {/* Status pill only belongs on the main facility page — the Fees / PIK /
            Amortization drill pages pass showStatusPill={false}. The
            Non-Pro-Rata alert icon shows regardless (unchanged from before). */}
        {showStatusPill && (
          <>
            <StatusPill
              updated={true}
              state={facility?.status ?? 'Draft'}
              additionalState={facility?.amendmentType ?? ''}
            />
            <FacilityHoldIndicator facility={facility} enableLift />
          </>
        )}
        {facility?.hasNonProRataLoans === true && (
          <NonProRataIconWithTooltip />
        )}
      </Group>
    </Stack>
  )
}
